import { View, ImageBackground } from "react-native";
import React from "react";
import { Faq, ShopPagePhaseTwo } from "lib/sanity.types";
import PlanGroups from "./components/PlanGroups";
import PortableText from "screens/Shop/components/PortableText";
import { getSanityImage } from "lib/sanity";
import Terms from "./components/Terms";
import Spacer from "components/Spacer";
import Faqs from "./components/Faqs";
import Container from "components/Container";

const StepOne = ({
  shopPage,
  faqs,
}: {
  shopPage: ShopPagePhaseTwo;
  faqs?: Faq[] | null;
}) => {
  return (
    <ImageBackground
      className="pt-16 md:pt-32"
      style={{
        backgroundColor: shopPage.stepOneBackgroundImageFilterColor.hex,
      }}
      source={{
        uri: getSanityImage(shopPage.stepOneBackgroundImage.asset._ref),
      }}
      imageStyle={{
        opacity: 0.3,
      }}
    >
      <View className="text-center">
        <View className="mb-16 md:mb-32 px-2">
          <PortableText value={shopPage.stepOneTitle} />
        </View>

        <PlanGroups groups={shopPage.groups} />

        {faqs && faqs.length > 0 && (
          <Spacer margin={64}>
            <Container>
              <Faqs faqs={faqs} />
            </Container>
          </Spacer>
        )}

        {shopPage.additionalCreative && (
          <View className="mt-32">
            <img
              src={getSanityImage(shopPage.additionalCreative.asset._ref)}
              alt=""
            />
          </View>
        )}

        <View className="mt-32 mb-8">
          <Terms tenantSubdomain={shopPage.subdomain} />
        </View>
      </View>
    </ImageBackground>
  );
};

export default StepOne;
